import { AG_GRID_LOCALE_VN } from "@ag-grid-community/locale";
import {
  Badge,
  Button,
  Flex,
  Grid,
  Group,
  Input,
  Select,
  SelectProps,
  Text,
  Title,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useDebouncedCallback } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconBrandBootstrap,
  IconBuildingSkyscraper,
  IconCheck,
  IconCoinPound,
  IconDeviceFloppy,
  IconListSearch,
  IconSearch,
  IconTicket,
  IconTimeDuration15,
  IconUser,
} from "@tabler/icons-react";
import {
  AllCommunityModule,
  CellDoubleClickedEvent,
  CellValueChangedEvent,
  ColDef,
  DetailGridInfo,
  FirstDataRenderedEvent,
  GridReadyEvent,
  ICellRendererParams,
  IRichCellEditorParams,
  themeQuartz,
  ValueFormatterParams,
} from "ag-grid-community";
import {
  ClientSideRowModelModule,
  DateEditorModule,
  MasterDetailModule,
  ModuleRegistry,
} from "ag-grid-enterprise";
import {
  AgGridReact,
  CustomCellEditorProps,
  CustomCellRendererProps,
} from "ag-grid-react";
import { MRT_PaginationState } from "mantine-react-table";
import React, {
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import {
  baseTheme,
  paginationPageSize,
  paginationPageSizeSelector,
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import { SelectListItemBase } from "../../../_base/model/_base/SelectListItemBase";
import { orange } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblDMPaymentMethod } from "../../../model/TblDMPaymentMethod";
import DebtObjectCodeFund from "../Bill/DebtObject/DebtObject";
import FormAccount from "../Bill/FormAccount/FormAccount";
import {
  AccountantAccount,
  DebtData,
  Permission,
  Program,
} from "../PaymentReceipt/InternalReceipt/InternalReceiptModel";
// import creatorbranchEditor from "./creatorbranchEdit";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { EmployeeModel } from "../../../model/Employee";
import { TblPaymentReceiptDetail } from "../../../model/PaymentReceiptDetailModel";
import CustomerByBranch from "../Bill/CustomerByBranch/CustomerByBranch";
import ListCustomer from "../Bill/ListCustomer/ListCustomer";
import ListEmployeebyBranch from "../Bill/ListEmployeebyBranch/ListEmployeebyBranch";
import ListEmployeebyBranch2 from "../Bill/ListEmployeebyBranch2/ListEmployeebyBranch2";
import ListSupplier from "../Bill/ListSupplier/ListSupplier";
import { CreateReceiptParentRequest } from "../PaymentReceipt/model/modelPaymentReceipt";
import {
  AccountantAccounts,
  Customer,
  DepartmentInfo,
  Vendor,
} from "./interfaceAdjustmentSlip";

ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  AllCommunityModule,
  DateEditorModule,
  MasterDetailModule,
]);

export const AdjustmentSlip = () => {
  const [height, setHeight] = useState(0);
  const sizeGrid = { base: 6, sm: 2, md: 2, lg: 2, xl: 2 };
  const [dataFetch, setDataFetch] = useState<DepartmentInfo[]>([]);
  const [dataBranch, setDataBranch] = useState<SelectListItemBase[]>([]);
  const [data, setData] = useState<TblPaymentReceiptDetail[]>([]);
  const [dataWarehouse, setDataWarehouse] = useState<SelectListItemBase[]>([]);
  const gridRef = useRef<AgGridReact<TblPaymentReceiptDetail>>(null);
  const [listBranch, setListBranch] = useState<any[]>([]);
  const navigate = useNavigate();
  const [dataAcount, setDataAcount] = useState<AccountantAccount[]>([]);
  const [dataCodeFund, setDataCodeFunch] = useState<SelectListItemBase[]>([]);
  const [employeesByRow, setEmployeesByRow] = useState<EmployeeModel[][]>([]);
  const [activeRowBranch, setActiveBranch] = useState<number | null>(null);
  const [activeRowIndex, setActiveRowIndex] = useState<number | null>(null);
  const [dataGetReceiptFee, setDataReceiptFee] = useState<Permission[]>([]);
  const [dataGetReceiptContract, setDataGetReceiptContract] = useState<
    Program[]
  >([]);
  const [search, setSearch] = useState({
    keySearch: "",
    customerId: "",
    Start: "",
    End: "",
    codefund: "",
    accountfund: "",
    ListNumber: "",
    deartment: "",
    branch: "",
    type: "",
    workplace: "",
    creator: "",
    Type: 0,
    typeReceipt: "",
  });

  const dataAccountFund = [
    { value: "1", label: "VND" },
    { value: "2", label: "USD" },
    { value: "3", label: "Vàng SJC 9999" },
    { value: "4", label: "Vàng PNJ 9999" },
  ];

  const optionColorsAccount: Record<
    "VND" | "USD" | "Vàng SJC 9999" | "Vàng PNJ 9999",
    string
  > = {
    VND: "cyan",
    USD: "green",
    "Vàng SJC 9999": "blue",
    "Vàng PNJ 9999": orange.medium,
  };

  const renderSelectOptionType: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={option.value === "1" ? "blue" : "green"}
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && <IconCheck style={{ marginInlineStart: "auto" }} />}
    </Group>
  );

  const headerRef = React.useRef<HTMLDivElement>(null);

  const containerStyle = useMemo(
    () => ({ width: "100%", height: height - 20, marginTop: "15px" }),
    [height],
  );

  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });

  const defaultColDef = useMemo<ColDef<TblPaymentReceiptDetail>>(() => {
    return {
      editable: true,
    };
  }, []);

  const myTheme = themeQuartz.withParams({
    fontSize: 12,
    headerFontSize: 14,
    spacing: 5,
    wrapperBorder: true,
    headerRowBorder: true,
    rowBorder: { style: "solid", color: "#dee2e6" },
    columnBorder: { style: "solid", color: "#dee2e6" },
  });

  const handleChangeSearchValue = useDebouncedCallback(
    (value: string, key: string) => {
      setSearch((prevData) => ({ ...prevData, [key]: value }));
    },
    500,
  );
  const renderSelectOptionAccount: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColorsAccount[
            option.label as "VND" | "USD" | "Vàng SJC 9999" | "Vàng PNJ 9999"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && <IconCheck style={{ marginInlineStart: "auto" }} />}
    </Group>
  );

  // Hàm gọi API phòng ban
  const fetchDataSelect = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<DepartmentInfo[]>>(
      "/api/v1/TblDepartment/get-all",
    );

    if (dataApi && dataApi.success) {
      setDataFetch(dataApi.data);
    }
  };
  // Hàm gọi API chi nhánh
  const fetchDataBranch = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmInventory/get-select-branch",
    );

    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data.slice(1);
      setDataBranch(filteredData);
    }
  };
  // Hàm gọi API nhân viên
  const fetchDataWarehouse = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmEmployee/get-select",
    );

    if (dataApi && dataApi.success) {
      setDataWarehouse(dataApi.data);
    }
  };
  //hàm get all chi nhánh
  const fetchDataBranchMaster = async () => {
    const response = await repositoryDelivery.get<
      MessageResponse<TblDMPaymentMethod[]>
    >("/api/v1/TblDmMasterOrg/get-all");

    if (response && response.success) {
      let result = response.data;
      setListBranch(result);
    }
  };
  //Hàm get tài khoản nợ và có
  const fetchDataReceiptAcount = async () => {
    const response = await repositoryPos.get<
      MessageResponse<AccountantAccount[]>
      //2 là phiếu báo có và phiếu báo nợ
    >("/api/v1/TblDmAccount/get-list?Skip=0&Take=999");

    if (response && response.success) {
      let result = response.data;
      setDataAcount(result);
    }
  };

  //Hàm gọi mã phí
  const getTblDmExpense = async () => {
    const response = await repositoryMdm.get<
      MessageResponse<SelectListItemBase[]>
    >("/api/v1/TblDmExpense/get-select");

    if (response && response.success) {
      let result = response.data;
      setDataCodeFunch(result);
    }
  };

  //Hàm gọi chi nhánh
  function cellRenderBranch(props: CustomCellRendererProps<DebtData>) {
    const data = dataBranch?.find((ele) => ele.att2 === props.value);
    return props.value ? (
      <span>{data?.att2 + " - " + data?.text}</span>
    ) : (
      <React.Fragment></React.Fragment>
    );
  }

  //Hàm gọi chứng từ khuyến mại
  function cellRenderCTKM(props: CustomCellRendererProps<DebtData>) {
    const data = dataGetReceiptFee?.find((ele) => ele.code === props.value);
    return props.value ? (
      <>
        <span>{data?.code + " - " + data?.name}</span>
      </>
    ) : (
      <React.Fragment></React.Fragment>
    );
  }

  //Hàm gọi chứng từ khuyễn mại
  const fetchDataReceiptFee = async () => {
    const response = await repositoryPos.get<MessageResponse<Permission[]>>(
      "/api/v1/TblDmFee/get-list?Skip=0&Take=9999",
    );

    if (response && response.success) {
      let result = response.data;
      setDataReceiptFee(result);
    }
  };

  //Hàm gọi hợp đồng
  function cellRenderContract(props: CustomCellRendererProps<DebtData>) {
    const data = dataGetReceiptContract?.find(
      (ele) => ele.code === props.value,
    );
    return props.value ? (
      <span>{data?.code + " - " + data?.name}</span>
    ) : (
      <React.Fragment></React.Fragment>
    );
  }
  //hàm gọi hợp đồng
  const fetchDataReceiptContract = async () => {
    const response = await repositoryPos.get<MessageResponse<Program[]>>(
      "/api/v1/TblDmContract/get-list?Skip=0&Take=2000",
    );

    if (response && response.success) {
      let result = response.data;
      setDataGetReceiptContract(result);
    }
  };

  const fetchEmployeeList = async (
    branchId: string,
    rowIndex: number | null,
  ) => {
    const selectedBranch = dataBranch?.find(
      (item) => String(item.att2) === String(branchId ?? ""),
    );

    if (!selectedBranch) return [];

    try {
      const response = await repositoryPos.get<
        MessageResponse<EmployeeModel[]>
      >(
        `/api/v1/TblDmEmployee/get-list?BranchId=${selectedBranch?.value}&Skip=0&Take=9999`,
      );

      if (response && response.success) {
        const employees = response.data;
        if (rowIndex !== null) {
          setEmployeesByRow((prev) => {
            const updatedEmployees = [...prev];
            updatedEmployees[rowIndex] = employees;
            return updatedEmployees;
          });
        } else {
          setEmployeesByRow([employees]);
        }
        return employees;
      }
    } catch (error) {
      console.error("Error fetching employee list:", error);
      return [];
    }
  };

  function cellRenderFee(props: CustomCellRendererProps<DebtData>) {
    const data = dataCodeFund.find((ele) => ele.att1 === props.value);
    return props.value ? <span>{data?.att1 + " - " + data?.text}</span> : null;
  }

  const onCellValueChanged = useCallback(
    (params: CellValueChangedEvent<TblPaymentReceiptDetail>) => {
      const colId = params.column.getId();
      const rowIndex = params.node.rowIndex;
      if (colId === "attribute5") {
        params.node.setDataValue("attribute5", params.value);
      }
      //Chọn người lập phiếu
      if (colId === "creatorbranch") {
        const text = dataBranch.find(
          (color) =>
            color.value.toString() === String(params.data.creatorbranch),
        );
        params.node.setDataValue("creatorworkplace", text?.att1 ?? "");
      } else if (colId === "fundbranch") {
        //Phòng ban người nộp nhận tiền
        const text = dataBranch.find(
          (color) => color.value.toString() === String(params.data.fundbranch),
        );
        params.node.setDataValue("fundworkplace", text?.att1 ?? "");
      }
    },
    [dataBranch],
  );

  const handleChooseDetailsCustomer = (
    value: any,
    isChooseCustomer: any,
    openFormCustomer: any,
    children?: boolean,
    RowIndex?: any,
  ) => {};

  const handleChooseAccount = (
    value: AccountantAccounts,
    openFormAccount: any,
  ) => {};

  function openFormDetailsCustomer(
    isChooseCongNo: boolean,
    openFormCustomer?: CellDoubleClickedEvent<any>,
    children?: boolean,
    RowIndex?: any,
  ) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Danh sách đối tượng công nợ</Title>
        </>
      ),
      size: "90vw",
      children: (
        <DebtObjectCodeFund
          isChooseCongNo={isChooseCongNo}
          handleChooseCustomer={handleChooseDetailsCustomer}
          navigate={navigate}
          disible
          children={children}
          RowIndex={RowIndex}
          paramDetailsEditThu={openFormCustomer}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function openFormDetailsEmployeeFund(
    isChooseCongNo: boolean,
    openFormCustomer?: CellDoubleClickedEvent<any>,
    children?: boolean,
    RowIndex?: any,
  ) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Danh sách nhân viên</Title>
        </>
      ),
      size: "90vw",
      children: (
        <CustomerByBranch
          isChooseCongNo={isChooseCongNo}
          handleChooseCustomer={handleChooseDetailsCustomer}
          navigate={navigate}
          disible
          children={children}
          RowIndex={RowIndex}
          paramDetailsEditEmployeeByBranch={openFormCustomer}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function openFormAccount(
    params: CellDoubleClickedEvent<any>,
    isChoose?: boolean,
  ) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Danh sách các tài khoản</Title>
        </>
      ),
      size: "70vw",
      children: (
        <FormAccount
          params={params}
          isChoose={isChoose}
          handleChooseAccount={handleChooseAccount}
          editCodeForFees={params}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  const handleListCustomerOrder = (
    value: any,
    params?: CellDoubleClickedEvent<TblPaymentReceiptDetail>,
  ) => {};

  const handleListEmployyee = (
    value: any,
    params?: CellDoubleClickedEvent<TblPaymentReceiptDetail>,
  ) => {
    if (value) {
      if (params?.colDef.field === "creatorfullname")
        //Nhân viên
        params?.node.setDataValue("creatorfullname", String(value.id));
      params?.node.setDataValue(
        "creatorfullnameTemp",
        value.code + " - " + value.fullname,
      );
      //Phòng ban
      params?.node.setDataValue(
        "creatordepartment",
        String(value.departmentId),
      );
      params?.node.setDataValue("creatordepartmentTemp", value.departmentName);
      //Bộ phận
      params?.node.setDataValue("createrolename", String(value.roleId));
      params?.node.setDataValue("createrolenameTemp", value.roleName);
    }
  };

  const handleListEmployyee2 = (
    value: any,
    params?: CellDoubleClickedEvent<TblPaymentReceiptDetail>,
  ) => {
    if (value) {
      if (params?.colDef.field === "funfullname") {
        //Nhân viên
        params?.node.setDataValue("funfullname", String(value.id));
        params?.node.setDataValue(
          "funfullnameTemp",
          value.code + " - " + value.fullname,
        );
        //Phòng ban
        params?.node.setDataValue("funddepartment", String(value.departmentId));
        params?.node.setDataValue("funddepartmentTemp", value.departmentName);
        //Bộ phận
        params?.node.setDataValue("attribute3", String(value.roleName));
        params?.node.setDataValue("attribute3Temp", value.roleName);
      }
    }
  };

  const handleListSupplier = (
    value: any,
    params?: CellDoubleClickedEvent<TblPaymentReceiptDetail>,
  ) => {};

  function openListFullName(params?: any) {
    console.log(params, "check");
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Danh sách nhân viên</Title>
        </>
      ),
      size: "90vw",
      children: (
        <ListEmployeebyBranch
          params={params}
          handleListEmployyee={handleListEmployyee}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function openListFullName2(params?: any) {
    console.log(params, "check");
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Danh sách nhân viên</Title>
        </>
      ),
      size: "90vw",
      children: (
        <ListEmployeebyBranch2
          params={params}
          handleListEmployyee2={handleListEmployyee2}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function openListCustomer(params?: any) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Danh sách khách hàng</Title>
        </>
      ),
      size: "90vw",
      children: (
        <ListCustomer
          params={params}
          handleListCustomer={handleListCustomerOrder}
        />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function openListSupplier(params: any) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Danh sách nhà cung cấp</Title>
        </>
      ),
      size: "90vw",
      children: (
        <ListSupplier params={params} handleListSupplier={handleListSupplier} />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  const fetchData = async () => {
    try {
      // Tạo queryParams, chỉ thêm các giá trị hợp lệ
      const queryParams: Record<string, string | number> = {};

      if (
        pagination.pageIndex !== undefined &&
        pagination.pageSize !== undefined
      ) {
        queryParams.Skip = pagination.pageIndex * pagination.pageSize;
        queryParams.Take = pagination.pageSize;
      }

      if (search.customerId) queryParams.CustomerId = search.customerId;
      if (search.Start) queryParams.Start = search.Start;
      if (search.End) queryParams.End = search.End;
      if (search.keySearch?.trim())
        queryParams.KeySearch = search.keySearch.toLowerCase();
      if (search.ListNumber?.trim())
        queryParams.ListNumber = search.ListNumber.toLowerCase();
      if (search.codefund) queryParams.Codefund = search.codefund;
      if (search.accountfund) queryParams.Accountfund = search.accountfund;
      if (search.creator) queryParams.Creator = search.creator;
      if (search.workplace) queryParams.Workplace = search.workplace;
      if (search.branch) queryParams.Branch = search.branch;
      if (search.type || search.Type)
        queryParams.Type = search.type || search.Type;
      if (search.typeReceipt) queryParams.TypeReceipt = search.typeReceipt;

      // Chuyển queryParams thành chuỗi URL
      const url =
        "/api/v1/CreateSellItem/get-list-receipt-edit?" +
        new URLSearchParams(queryParams as Record<string, string>).toString();

      // Gọi API
      const response =
        await repositoryPos.get<MessageResponse<TblPaymentReceiptDetail[]>>(
          url,
        );

      if (response && response.success) {
        setData(response.data);
        // setRowCount(response.totalCount);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const createsaleBrandRender = (props: CustomCellRendererProps) => {
    const text = dataBranch.find((color) => color.value === props.value)?.text;
    return <>{text}</>;
  };

  //#region Người lập phiếu
  const editCode = memo(
    ({
      value,
      onValueChange,
      stopEditing,
      node,
      api,
    }: CustomCellEditorProps) => {
      const refContainer = useRef<HTMLDivElement>(null);

      useEffect(() => {
        refContainer.current?.focus();
      }, []);

      const onClick = (newBranchValue: string | null) => {
        const x = dataCodeFund.find((ele) => ele.att1 === newBranchValue);
        onValueChange(newBranchValue);
        stopEditing();
        node.setDataValue("codeForFees", x?.text);
      };

      return (
        <div ref={refContainer} tabIndex={1}>
          <Select
            searchable
            clearable
            placeholder="Mã phí"
            comboboxProps={{
              transitionProps: { transition: "pop", duration: 200 },
            }}
            limit={50}
            leftSection={<IconBrandBootstrap color="#15aabf" />}
            data={dataCodeFund.map((item) => ({
              label: item.att1 + " - " + item.text,
              value: String(item.att1 ?? ""),
            }))}
            value={value}
            onChange={(value) => onClick(value)}
          />
        </div>
      );
    },
  );
  //Chi nhánh của người lập phiếu
  const createSaleBrandEdit = memo(
    ({
      value,
      onValueChange,
      stopEditing,
      node,
      api,
    }: CustomCellEditorProps) => {
      const refContainer = useRef<HTMLDivElement>(null);

      useEffect(() => {
        refContainer.current?.focus();
      }, []);

      const onClick = (newBranchValue: string | null) => {
        onValueChange(newBranchValue);
        stopEditing();
      };

      return (
        <div ref={refContainer} tabIndex={1}>
          <Select
            searchable
            clearable
            placeholder="Chi nhánh"
            comboboxProps={{
              transitionProps: { transition: "pop", duration: 200 },
            }}
            limit={50}
            leftSection={<IconBrandBootstrap color="#15aabf" />}
            data={dataBranch.map((item) => ({
              label: item.text ?? "",
              value: String(item.value ?? ""),
            }))}
            value={value}
            onChange={(value) => onClick(value)}
          />
        </div>
      );
    },
  );

  useEffect(() => {
    fetchDataBranch();
    getTblDmExpense();
    fetchDataSelect();
    fetchDataReceiptFee();
    fetchDataReceiptContract();
  }, []);

  const [listEmployee, setListEmployee] = useState<EmployeeModel[]>([]);
  const [listCustomer, setListCustomer] = useState<Customer[]>([]);
  const [dataListVendor, setdataListVendor] = useState<Vendor[]>([]);

  const fetchDataEmployee = async () => {
    // const selectedBranch = dataBranch?.find(
    //   (item) => String(item.value) === String(params.data.creatorbranch)
    // );
    const response = await repositoryPos.post<MessageResponse<EmployeeModel[]>>(
      `/api/v1/TblDmEmployee/get-list-by-list-id`,
      {
        EmpIds: data.map((x) => Number.parseInt(x.creatorfullname)),
      },
    );

    if (response?.success) {
      setListEmployee(response.data);
    }
  };

  const fetchDataCustomer = async () => {
    // const selectedBranch = dataBranch?.find(
    //   (item) => String(item.value) === String(params.data.creatorbranch)
    // );
    const response = await repositoryPos.post<MessageResponse<Customer[]>>(
      `/api/v1/TblDmCustomer/get-list-by-ids`,
      {
        ids: data
          .filter((x) => x.payertype === "Khách hàng")
          .map((x) => Number.parseInt(x.codecustomer))
          .filter(Boolean),
      },
    );

    if (response?.success) {
      setListCustomer(response.data);
    }
  };

  const fetchDataVendor = async () => {
    const vendors = data
      .filter((x) => x.payertype === "NCC") // Lọc trước khi map
      .map((x) => Number.parseInt(x.codecustomer)) // Chuyển đổi sang số
      .filter((code) => !isNaN(code)); // Loại bỏ giá trị không hợp lệ

    const response = await repositoryMdm.post<MessageResponse<Vendor[]>>(
      `/api/v1/TblVendor/get-by-ids`,
      vendors,
    );

    if (response?.success) {
      setdataListVendor(response.data);
    }
  };

  // useEffect(() => {
  //   fetchDataCustomer();
  //   fetchDataVendor();
  // }, [ data]);

  const EmployeeCellRenderer = (params: CustomCellEditorProps<any>) => {
    const x = listEmployee.find(
      (ele) => String(ele.id) === String(params.data.creatorfullname),
    );
    const y = listEmployee.find(
      (ele) => String(ele.id) === String(params.data.funfullname),
    );
    //===============================================
    params?.node.setDataValue(
      "creatorfullnameTemp",
      String(x?.code + " - " + x?.fullname),
    );
    params?.node.setDataValue("creatordepartmentTemp", x?.departmentName);
    params?.node.setDataValue("createrolenameTemp", x?.roleName);

    //===============================================
    params?.node.setDataValue(
      "funfullnameTemp",
      String(y?.code + " - " + y?.fullname),
    );
    params?.node.setDataValue("funddepartmentTemp", y?.departmentName);
    params?.node.setDataValue("attribute3Temp", y?.roleName);

    if (params.colDef.field === "creatorfullname") {
      return (
        <>
          {x?.fullname || x?.code
            ? params.data?.creatorfullnameTemp
            : params.data?.creatorfullname}
        </>
      );
    } else if (params.colDef.field === "creatordepartment") {
      return (
        <>
          {x?.departmentName
            ? params.data?.creatordepartmentTemp
            : params.data?.creatordepartment}
        </>
      );
    } else if (params.colDef.field === "createrolename") {
      return (
        <>
          {x?.roleName
            ? params.data?.createrolenameTemp
            : params.data?.createrolename}
        </>
      );
    } else if (params.colDef.field === "funfullname") {
      return (
        <>
          {y?.fullname
            ? params.data?.funfullnameTemp
            : params.data?.funfullname}
        </>
      );
    } else if (params.colDef.field === "funddepartment") {
      return (
        <>
          {y?.departmentName
            ? params.data?.funddepartmentTemp
            : params.data?.funddepartment}
        </>
      );
    } else if (params.colDef.field === "attribute3") {
      return (
        <>
          {y?.roleName ? params.data?.attribute3Temp : params.data?.attribute3}
        </>
      );
    }
  };

  console.log(listCustomer, dataListVendor, "check1212121");
  const CustomerCellRenderer = (params: CustomCellEditorProps<any>) => {
    if (params.data.payertype === "Khách hàng") {
      const x = listCustomer?.find(
        (ele) => String(ele.id) === String(params.data.codecustomer),
      );
      //===============================================
      params?.node.setDataValue("codeCustomerTemp", String(x?.code));
      params?.node.setDataValue("codecustomer", x?.id);
      params?.node.setDataValue("anothername", x?.name);
      params?.node.setDataValue("phonenumber", x?.telephoneNumber);
      //===============================================
      if (params.colDef.field === "codecustomer") {
        return (
          <>
            {x?.code
              ? params.data?.codeCustomerTemp
              : params.data?.codecustomer}
          </>
        );
      }
    } else if (params.data.payertype === "NCC") {
      const x = dataListVendor?.find(
        (ele) => String(ele.id) === String(params.data.codecustomer),
      );
      //===============================================
      params?.node.setDataValue("codeCustomerTemp", String(x?.vendorCode));
      params?.node.setDataValue("codecustomer", x?.id);
      params?.node.setDataValue("anothername", x?.vendorName);
      params?.node.setDataValue("phonenumber", x?.phone);
      //===============================================

      if (params.colDef.field === "codecustomer") {
        return (
          <>
            {x?.vendorCode
              ? params.data?.codeCustomerTemp
              : params.data?.codecustomer}
          </>
        );
      }
    }
  };

  //danh sách theo từng hàng
  const columnDefs = useMemo<ColDef<TblPaymentReceiptDetail>[]>(
    () => [
      {
        field: "receiptNumber",
        headerName: "Mã phiếu",
        filter: "agTextColumnFilter",
        pinned: "left",
        maxWidth: 200,
        editable: false,
        cellRenderer: "agGroupCellRenderer",
      },
      {
        field: "completiontime",
        headerName: "Thời gian hoàn thành",
        valueFormatter: (
          params: ValueFormatterParams<TblPaymentReceiptDetail, Date>,
        ) => {
          if (!params.value) {
            return "";
          }

          const date = new Date(params.value);
          if (isNaN(date.getTime())) {
            return "Sai định dạng ngày !";
          }

          const year = date.getFullYear();
          const month = date.getMonth() + 1;
          const day = date.getDate();
          const hours = date.getHours();
          const minutes = date.getMinutes();
          const seconds = date.getSeconds();

          return `${year}-${month < 10 ? "0" + month : month}-${
            day < 10 ? "0" + day : day
          } ${hours < 10 ? "0" + hours : hours}:${
            minutes < 10 ? "0" + minutes : minutes
          }:${seconds < 10 ? "0" + seconds : seconds}`;
        },
        cellEditor: "agTextCellEditor",
        minWidth: 200,
      },
      {
        field: "type",
        headerName: "Loại phiếu thu / chi",
        filter: "agNumberColumnFilter",
        editable: false,
        minWidth: 200,
        maxWidth: 200,
        cellRenderer: (
          params: CustomCellRendererProps<TblPaymentReceiptDetail>,
        ) => {
          let typeOptions: { value: string; label: string }[] = [];

          if (params.data?.receiptNumber.includes("TH")) {
            typeOptions = [
              { value: "1", label: "Phiếu thu đơn hàng" },
              { value: "5", label: "Phiếu thu khác" },
            ];
          } else if (params.data?.receiptNumber.includes("CH")) {
            typeOptions = [
              { value: "2", label: "Phiếu chi đơn hàng" },
              { value: "5", label: "Phiếu chi khác" },
            ];
          } else if (params.data?.receiptNumber.includes("BC")) {
            typeOptions = [
              { value: "6", label: "Phiếu báo có đơn hàng" },
              { value: "4", label: "Phiếu báo có khác" },
            ];
          } else if (params.data?.receiptNumber.includes("BN")) {
            typeOptions = [{ value: "3", label: "Phiếu báo nợ" }];
          }
          const locatorId = params?.data?.type?.toString();
          const selectedOption = typeOptions.find(
            (opt) => opt.value === locatorId,
          );
          return <>{selectedOption ? selectedOption.label : null}</>;
        },
      },
      {
        field: "creatorbranch",
        headerName: "Chi nhánh người lập phiếu",
        filter: "agTextColumnFilter",
        minWidth: 230,
        cellEditor: createSaleBrandEdit,
        cellRenderer: createsaleBrandRender,
        cellEditorPopup: true,
      },
      {
        field: "creatorworkplace",
        headerName: "Địa điểm người lập phiếu",
        filter: "agTextColumnFilter",
        minWidth: 250,
        editable: false,
      },
      {
        field: "creatorfullname",
        headerName: "Họ tên người lập phiếu",
        filter: "agTextColumnFilter",
        minWidth: 300,
        editable: false,
        cellEditorPopup: true,
        onCellDoubleClicked: (
          params: CellDoubleClickedEvent<TblPaymentReceiptDetail>,
        ) => {
          openListFullName(params);
        },
        cellRenderer: EmployeeCellRenderer,
      },
      {
        field: "creatordepartment",
        headerName: "Phòng ban người lập phiếu",
        filter: "agTextColumnFilter",
        editable: false,
        minWidth: 300,
        cellEditorPopup: true,
        cellRenderer: EmployeeCellRenderer,
      },
      {
        field: "createrolename",
        headerName: "Chức danh người lập phiếu",
        minWidth: 300,
        editable: false,
        cellRenderer: EmployeeCellRenderer,
      },
      {
        field: "payertype",
        headerName: "Loại",
        cellEditor: "agRichSelectCellEditor",
        filter: "agTextColumnFilter",
        minWidth: 150,
        cellEditorParams: {
          values: ["Nội bộ", "Khách hàng", "NCC", "Khác"],
        },
        editable: true,
      },
      {
        field: "fundbranch",
        headerName: "Chi nhánh người nộp / nhận tiền",
        filter: "agTextColumnFilter",
        minWidth: 300,
        cellEditor: createSaleBrandEdit,
        cellRenderer: createsaleBrandRender,
      },
      {
        field: "fundworkplace",
        headerName: "Địa điểm người nộp / nhận tiền",
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        editable: false,
        minWidth: 300,
      },
      {
        field: "funfullname",
        headerName: "Họ tên người nộp / nhận tiền",
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        onCellDoubleClicked: (
          params: CellDoubleClickedEvent<TblPaymentReceiptDetail>,
        ) => {
          openListFullName2(params);
        },
        cellRenderer: EmployeeCellRenderer,
        editable: false,
        minWidth: 300,
      },
      {
        field: "funddepartment",
        headerName: "Phòng ban người nộp / nhận tiền",
        filter: "agTextColumnFilter",
        editable: false,
        minWidth: 300,
        cellEditorPopup: true,
        cellRenderer: EmployeeCellRenderer,
      },
      {
        field: "attribute3",
        headerName: "Chức danh người nộp / nhận tiền",
        cellEditor: "agTextCellEditor",
        editable: false,
        filter: "agTextColumnFilter",
        minWidth: 300,
        cellRenderer: EmployeeCellRenderer,
      },
      {
        field: "codecustomer",
        headerName: "Mã KH/NCC/Khác",
        filter: "agTextColumnFilter",
        cellEditor: "agTextCellEditor",
        onCellDoubleClicked: (
          params: CellDoubleClickedEvent<TblPaymentReceiptDetail>,
        ) => {
          if (params.data?.payertype === "Khách hàng") {
            openListCustomer(params);
          } else if (params.data?.payertype === "NCC") {
            openListSupplier(params);
          } else if (
            params.data?.payertype === "Nội bộ" ||
            params.data?.payertype === "Khác"
          ) {
            NotificationExtension.Warn("Vui lòng chọn loại (Khách hàng, NCC)");
          }
        },
        minWidth: 200,
        maxWidth: 200,
        // cellRenderer: codeCustomersCellRenderer,
        cellRenderer: (
          props: CustomCellRendererProps<TblPaymentReceiptDetail>,
        ) => {
          return (
            <>{props.data?.codeCustomerTemp ?? props.data?.codecustomer}</>
          );
        },
        editable: false,
      },
      {
        field: "anothername",
        headerName: "Tên KH/NCC/Khác",
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        editable: true,
        minWidth: 200,
      },
      {
        field: "phonenumber",
        headerName: "Số điện thoại KH/NCC/Khác",
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        editable: true,
        minWidth: 200,
      },
      {
        field: "payerdescription",
        headerName: "Nội dung",
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        editable: true,
        minWidth: 300,
      },
      {
        field: "attribute2",
        headerName: "Mã đối tượng công nợ",
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        minWidth: 300,
        onCellDoubleClicked: (params: CellDoubleClickedEvent<any>) => {
          openFormDetailsCustomer(true, params);
        },
        editable: false,
      },
      {
        field: "attribute7",
        headerName: "Tên đối tượng công nợ",
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        minWidth: 300,
        editable: false,
      },
      {
        field: "accountfund",
        headerName: "Tỷ giá",
        filter: "agTextColumnFilter",
        cellEditor: "agRichSelectCellEditor",
        cellEditorParams: {
          values: ["VND", "USD", "GOLD"],
        },
        minWidth: 150,
        maxWidth: 150,
        editable: true,
      },
      {
        field: "codefund",
        headerName: "Mã tài khoản",
        cellEditor: "agNumberCellEditor",
        filter: "agNumberColumnFilter",
        minWidth: 150,
        maxWidth: 150,
        editable: false,
        onCellDoubleClicked: (
          params: CellDoubleClickedEvent<TblPaymentReceiptDetail>,
        ) => {
          openFormAccount(params);
        },
      },
      {
        field: "attribute6",
        headerName: "Tên tài khoản",
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        minWidth: 300,
        editable: false,
      },
      {
        field: "attribute5",
        headerName: "Tên tài khoản",
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        hide: true,
      },
      {
        field: "codeCustomerTemp",
        headerName: "Tên tài khoản",
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        hide: true,
      },
      {
        field: "creatorfullnameTemp",
        headerName: "Tên tài khoản",
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        hide: true,
      },
      {
        field: "createrolenameTemp",
        headerName: "Tên tài khoản",
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        hide: true,
      },
      {
        field: "creatordepartmentTemp",
        headerName: "Tên tài khoản",
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        hide: true,
      },
      {
        field: "funfullnameTemp",
        headerName: "Tên tài khoản",
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        hide: true,
      },
      {
        field: "funddepartmentTemp",
        headerName: "Tên tài khoản",
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        hide: true,
      },
      {
        field: "attribute3Temp",
        headerName: "Tên tài khoản",
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        hide: true,
      },
      {
        field: "attribute8",
        headerName: "Mã giao dịch",
        cellEditor: "agTextCellEditor",
        filter: "agTextColumnFilter",
        minWidth: 150,
        editable: (params) => {
          return ["BC", "BN"].some((prefix) =>
            params.data?.receiptNumber?.startsWith(prefix),
          );
        },
        onCellDoubleClicked: (
          params: CellDoubleClickedEvent<TblPaymentReceiptDetail>,
        ) => {
          if (
            ["BC", "BN"].some((prefix) =>
              params.data?.receiptNumber?.startsWith(prefix),
            )
          ) {
            return;
          } else {
            NotificationExtension.Info("Mã phiếu này không có mã giao dịch");
          }
        },
      },
      {
        field: "totalAmount",
        headerName: "Tổng tiền",
        editable: false,
        minWidth: 120,
        maxWidth: 150,
        pinned: "right",
        cellEditor: "agNumberCellEditor",
        filter: "agTextColumnFilter",
      },
    ],
    [dataBranch, listEmployee],
  );

  const handleComplete = async () => {
    try {
      const response = await repositoryPos.post<
        MessageResponse<CreateReceiptParentRequest>
      >("api/v1/CreateSellItem/update-recpit", {
        receiptDetails: data,
      });

      if (response?.success) {
        NotificationExtension.Success("Điều chỉnh phiếu thành công!");
      } else {
        NotificationExtension.Fails("Điều chỉnh phiếu thất bại!");
      }
    } catch (error) {
      NotificationExtension.Fails("Có lỗi xảy ra khi điều chỉnh phiếu!");
    }
  };

  const onFirstDataRendered = useCallback(
    (params: FirstDataRenderedEvent) => {},
    [],
  );

  const DetailCellRenderer = ({
    data,
    node,
    api,
  }: CustomCellRendererProps<TblPaymentReceiptDetail>) => {
    const rowId = node.id!;
    const [dataJson, setDataJson] = useState<DebtData[]>([]);
    const type = data?.type;
    const typeReceipt = data?.typeReceipt;

    useEffect(() => {
      if (data?.attribute5) setDataJson(JSON.parse(data.attribute5));
      return () => {
        if (!api.isDestroyed()) {
          console.log("removing detail grid info with id: ", rowId);
          api.removeDetailGridInfo(rowId);
        }
      };
    }, []);

    useEffect(() => {
      fetchEmployeeList(String(data?.creatorbranch), node.rowIndex);
    }, [data]);

    const colDefs = useMemo<ColDef<any>[]>(() => {
      if (typeReceipt === 1) {
        if (type === 1 || type === 6) {
          return [
            {
              field: "STT",
              headerName: "Số thứ tự",
              minWidth: 40,
              maxWidth: 40,
              pinned: "left",
              valueGetter: (params) => Number(params?.node?.rowIndex) + 1,
            },
            {
              field: "orderNumber",
              headerName: "Số đơn hàng",
              minWidth: 80,
              editable: false,
              filter: "agTextColumnFilter",
              cellEditor: "agTextCellEditor",
            },
            {
              field: "attribute2",
              headerName: "Mã đối tượng công nợ",
              minWidth: 80,
              filter: "agTextColumnFilter",
              cellEditor: "agTextCellEditor",
              onCellDoubleClicked: (params: CellDoubleClickedEvent<any>) => {
                openFormDetailsCustomer(true, params);
              },
              editable: false,
            },
            {
              field: "attribute7",
              headerName: "Tên đối tượng công nợ",
              minWidth: 80,
              filter: "agTextColumnFilter",
              cellEditor: "agTextCellEditor",
              editable: false,
            },
            {
              field: "amountTotal",
              headerName: "Tổng tiền hóa đơn",
              editable: false,
              minWidth: 80,
              filter: "agTextColumnFilter",
              cellEditor: "agNumberCellEditor",
            },
            {
              field: "amountPaid",
              headerName: "Số đã thanh toán",
              minWidth: 80,
              editable: false,
              filter: "agTextColumnFilter",
              cellEditor: "agNumberCellEditor",
            },
            {
              field: "amountRemaining",
              headerName: "Số còn phải thanh toán",
              minWidth: 80,
              editable: false,
              filter: "agTextColumnFilter",
              cellEditor: "agNumberCellEditor",
            },
            {
              field: "allocatedAmount",
              headerName: "Số tiền phân bổ",
              editable: false,
              minWidth: 80,
              filter: "agTextColumnFilter",
              cellEditor: "agNumberCellEditor",
            },
            {
              field: "note",
              headerName: "Diễn giải",
              minWidth: 80,
              editable: true,
              filter: "agTextColumnFilter",
              cellEditor: "agTextCellEditor",
            },
          ];
        }
      }

      return [
        {
          field: "originalDocuments",
          headerName: "Tên chứng từ",
          minWidth: 150,
          filter: "agTextColumnFilter",
          editable: false,
        },
        {
          field: "originalDocumentNumber",
          headerName: "Số Chứng Từ Gốc",
          cellEditor: "agTextCellEditor",
          minWidth: 200,
          editable: false,
          filter: "agTextColumnFilter",
        },
        // {
        //   field: "code",
        //   headerName: "Mã Phí",
        //   filter: "agTextColumnFilter",
        //   minWidth: 250,
        //   cellRenderer: cellRenderFee,
        //   cellEditor: editCode,
        //   cellEditorParams: (params: CustomCellRendererProps) => {
        //     return {
        //       values: dataCodeFund?.map((ele) => ele.att1) || [],
        //       allowTyping: true,
        //       filterList: true,
        //       highlightMatch: true,
        //       cellRenderer: cellRenderFee,
        //     };
        //   },
        // },
        {
          field: "code",
          headerName: "Tài khoản",
          cellEditor: "agTextCellEditor",
          filter: "agTextColumnFilter",
          minWidth: 300,
          onCellDoubleClicked: (params: CellDoubleClickedEvent<any>) => {
            openFormAccount(params, true);
          },
          editable: false,
        },
        {
          field: "codeForFees",
          headerName: "Tên Phí",
          editable: false,
          filter: "agTextColumnFilter",
          minWidth: 250,
          hide: true,
        },
        {
          field: "occurringCredit",
          headerName: "Phát Sinh Có",
          editable: false,
          minWidth: 200,
          cellEditor: "agNumberCellEditor",
        },
        {
          field: "debtObjectCode",
          headerName: "Mã Đối Tượng Công Nợ",
          cellEditor: "agTextCellEditor",
          filter: "agTextColumnFilter",
          minWidth: 200,
          onCellDoubleClicked: (params: CellDoubleClickedEvent<any>) => {
            openFormDetailsCustomer(true, params);
          },
          editable: false,
        },
        {
          field: "debtObjectName",
          headerName: "Tên Đối Tượng Công Nợ",
          cellEditor: "agTextCellEditor",
          editable: false,
          filter: "agTextColumnFilter",
          minWidth: 250,
        },
        {
          field: "description",
          headerName: "Nội Dung",
          filter: "agTextColumnFilter",
          cellEditor: "agTextCellEditor",
        },
        {
          field: "branchesFund",
          headerName: "Chi nhánh",
          cellRenderer: cellRenderBranch,
          cellEditor: "agRichSelectCellEditor",
          filter: "agTextColumnFilter",
          minWidth: 220,
          cellEditorParams: {
            values: dataBranch
              ?.slice(1)
              ?.sort((a: any, b: any) => a.att2 - b.att2)
              .map((ele) => ele.att2),
            allowTyping: true,
            filterList: true,
            highlightMatch: true,
            cellRenderer: cellRenderBranch,
          } as IRichCellEditorParams,
        },
        {
          field: "employeeFund",
          headerName: "Mã NV",
          cellEditor: "agRichSelectCellEditor",
          filter: "agTextColumnFilter",
          minWidth: 220,
          editable: false,
          onCellDoubleClicked: (params: CellDoubleClickedEvent<any>) => {
            openFormDetailsEmployeeFund(true, params);
          },
        },
        {
          field: "fee",
          headerName: "CTKM",
          cellEditor: "agRichSelectCellEditor",
          filter: "agTextColumnFilter",
          minWidth: 220,
          cellRenderer: cellRenderCTKM,
          cellEditorParams: {
            values: dataGetReceiptFee?.map((ele) => ele.code),
            allowTyping: true,
            filterList: true,
            highlightMatch: true,
            cellRenderer: cellRenderCTKM,
          } as IRichCellEditorParams,
        },
        {
          field: "contract",
          headerName: "Hợp Đồng",
          cellEditor: "agRichSelectCellEditor",
          filter: "agNumberColumnFilter",
          minWidth: 250,
          cellRenderer: cellRenderContract,
          cellEditorParams: {
            values: dataGetReceiptContract?.map((ele) => ele.code),
            allowTyping: true,
            filterList: true,
            highlightMatch: true,
            //highlightMatch hoạt động khi không set cellRenderer
            cellRenderer: cellRenderContract,
          } as IRichCellEditorParams,
        },
      ];
    }, [dataCodeFund, typeReceipt, type, dataBranch, employeesByRow]);

    const defaultColDef: ColDef = {
      editable: true,
    };
    const onGridReady = (params: GridReadyEvent) => {
      const gridInfo: DetailGridInfo = {
        id: rowId,
        api: params.api,
      };
      console.log("adding detail grid info with id: ", rowId);
      api.addDetailGridInfo(rowId, gridInfo);
    };
    return (
      <div
        className="full-width-panel"
        style={{ height: "300px", boxSizing: "border-box", paddingTop: "10px" }}
      >
        <AgGridReact
          className="full-width-grid"
          columnDefs={colDefs}
          theme={myTheme}
          defaultColDef={defaultColDef}
          rowData={dataJson}
          onCellValueChanged={(params) => {
            const colId = params.column.getId();
            const rowIndex = params.node.rowIndex;
            node.setDataValue("attribute5", JSON.stringify(dataJson));
          }}
          onGridReady={onGridReady}
        />
      </div>
    );
  };

  useEffect(() => {
    if (pagination.pageIndex === 0 && data.length < pagination.pageSize) {
      fetchData();
    } else {
      fetchData();
    }
  }, [pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    fetchDataBranchMaster();
    fetchDataReceiptAcount();
  }, []);

  useEffect(() => {
    fetchDataEmployee();
  }, []);

  useEffect(() => {
    fetchEmployeeList(String(activeRowBranch), activeRowIndex);
  }, [activeRowBranch, activeRowIndex]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (185 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  return (
    <div style={containerStyle}>
      <Group justify="space-between">
        <_breadcrumb></_breadcrumb>
        <Flex gap={10}>
          {/* <Button
            leftSection={<IconCheck size={14} />}
            color="green"
            bd="1px solid green"
            variant="violet"
            onClick={() => console.log(data)}
          >
            chekc
          </Button> */}
          <Button
            leftSection={<IconDeviceFloppy size={14} />}
            color="blue"
            bd="1px solid blue"
            variant="light"
            onClick={() => handleComplete()}
          >
            Lưu thay đổi
          </Button>
        </Flex>
      </Group>
      <Grid mt={5} mb={5}>
        <Grid.Col span={{ base: 6, sm: 6, md: 6, lg: 4 }}>
          <Input
            placeholder="Từ khóa (Tìm nhiều mã phiếu VD: TH1, BC2, CH3)"
            type="text"
            onChange={(e) => {
              handleChangeSearchValue(e.target.value ?? "", "ListNumber");
            }}
            leftSection={<IconListSearch color="#15aabf" />}
            onKeyDown={async (e) => {
              if (e.key === "Enter") {
                await fetchData();
              }
            }}
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Input
            placeholder="Từ khóa"
            type="text"
            onChange={(e) => {
              handleChangeSearchValue(e.target.value ?? "", "keySearch");
            }}
            leftSection={<IconSearch color="#15aabf" />}
            onKeyDown={async (e) => {
              if (e.key === "Enter") {
                await fetchData();
              }
            }}
          />
        </Grid.Col>
        <Grid.Col
          span={sizeGrid}
          // style={{ flexBasis: "100%", maxWidth: "320px", flex: "1" }}
        >
          <DatePickerInput
            type="default"
            leftSection={<IconTimeDuration15 color="#15aabf" />}
            size="sm"
            placeholder="Từ ngày"
            locale="vi"
            //   value={value}
            valueFormat="DD/MM/YYYY"
            onChange={(e) => {
              const startDateFormatted = e
                ? `${e.getMonth() + 1}/${e.getDate()}/${e.getFullYear()}`
                : null; // Định dạng MM/DD/YYYY
              handleChangeSearchValue(startDateFormatted ?? "", "Start");
            }}
            clearable
          />
        </Grid.Col>
        <Grid.Col
          span={sizeGrid}
          // style={{ flexBasis: "100%", maxWidth: "320px", flex: "1" }}
        >
          <DatePickerInput
            leftSection={<IconTimeDuration15 color="#15aabf" />}
            size="sm"
            placeholder="Đến ngày"
            locale="vi"
            //  value={value}
            valueFormat="DD/MM/YYYY"
            onChange={(e) => {
              const startDateFormatted = e
                ? `${e.getMonth() + 1}/${e.getDate()}/${e.getFullYear()}`
                : null; // Định dạng MM/DD/YYYY
              handleChangeSearchValue(startDateFormatted ?? "", "End");
            }}
            clearable
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Select
            searchable
            clearable
            placeholder="Phòng ban"
            limit={50}
            leftSection={<IconBuildingSkyscraper color="#15aabf" />}
            comboboxProps={{
              transitionProps: { transition: "pop", duration: 200 },
            }}
            data={dataFetch
              .filter((item) => item.name !== "Tất cả")
              .map((item) => {
                return {
                  label: "[" + item.deparmentCode + "] " + item.name,
                  value: String(item.departmentId ?? ""),
                };
              })}
            onChange={(value) => {
              handleChangeSearchValue(value ?? "", "department");
            }}
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Select
            searchable
            clearable
            placeholder="Chi nhánh"
            comboboxProps={{
              transitionProps: { transition: "pop", duration: 200 },
            }}
            limit={50}
            leftSection={<IconBrandBootstrap color="#15aabf" />}
            data={dataBranch.map((item) => {
              return {
                label: item.text ?? "",
                value: String(item.value ?? ""),
              };
            })}
            onChange={(value) => {
              handleChangeSearchValue(value ?? "", "branch");
            }}
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Select
            searchable
            clearable
            placeholder="Nhân viên"
            leftSection={<IconUser color="#15aabf" />}
            comboboxProps={{
              transitionProps: { transition: "pop", duration: 200 },
            }}
            limit={50}
            data={dataWarehouse.map((item) => {
              return {
                label: item.text ?? "",
                value: String(item.value ?? ""),
              };
            })}
            onClick={async () => {
              if (!dataWarehouse || dataWarehouse.length < 1) {
                await fetchDataWarehouse();
              }
              return;
            }}
            onChange={(value) => {
              handleChangeSearchValue(value ?? "", "creator");
            }}
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Select
            searchable
            clearable
            placeholder="Tài khoản quỹ"
            leftSection={<IconCoinPound color="#15aabf" />}
            limit={50}
            comboboxProps={{
              transitionProps: { transition: "pop", duration: 200 },
            }}
            data={dataAccountFund}
            onChange={(value) => {
              handleChangeSearchValue(value ?? "", "accountfund");
            }}
            renderOption={renderSelectOptionAccount}
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Select
            searchable
            clearable
            placeholder="Loại phiếu"
            leftSection={<IconTicket color="#15aabf" />}
            limit={50}
            comboboxProps={{
              transitionProps: { transition: "pop", duration: 200 },
            }}
            data={[
              { value: "1", label: "Thu" },
              { value: "2", label: "Chi" },
            ]}
            onChange={(value) => {
              handleChangeSearchValue(value ?? "", "typeReceipt");
            }}
            renderOption={renderSelectOptionType}
          />
        </Grid.Col>

        <Grid.Col span={sizeGrid}>
          <Select
            searchable
            clearable
            placeholder="Kiểu phiếu"
            leftSection={<IconTicket color="#15aabf" />}
            limit={50}
            comboboxProps={{
              transitionProps: { transition: "pop", duration: 200 },
            }}
            data={[
              { value: "1", label: "Đơn hàng" },
              { value: "2", label: "Nội bộ" },
              { value: "3", label: "Báo nợ" },
              { value: "4", label: "Báo có" },
              { value: "5", label: "Khác" },
            ]}
            onChange={(value) => {
              handleChangeSearchValue(value ?? "", "type");
            }}
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Button
            leftSection={<IconSearch size={14} />}
            color="blue"
            variant="outline"
            onClick={async () => {
              await fetchData();
            }}
          >
            Tìm kiếm
          </Button>
        </Grid.Col>
      </Grid>

      <div
        style={{ height: "100%", boxSizing: "border-box", paddingTop: "10px" }}
      >
        <AgGridReact<TblPaymentReceiptDetail>
          ref={gridRef}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          onCellValueChanged={onCellValueChanged}
          rowData={data}
          theme={myTheme}
          suppressColumnVirtualisation={true}
          suppressRowVirtualisation={true}
          pagination={true}
          localeText={AG_GRID_LOCALE_VN}
          masterDetail={true}
          detailCellRenderer={DetailCellRenderer}
          detailRowAutoHeight={true}
          autoSizeStrategy={{
            type: "fitCellContents",
          }}
          paginationPageSize={paginationPageSize}
          paginationPageSizeSelector={paginationPageSizeSelector}
          onFirstDataRendered={onFirstDataRendered}
        />
      </div>
    </div>
  );
};
